import { React } from '@/vendor'
import { useLocation } from 'react-router-dom'

export default (callback) => {
	const { pathname } = useLocation()
	React.useEffect(callback, [pathname])
}
